module.exports = __webpack_public_path__ + "static/img/side-back.154db8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/index/side-back.png
// module id = Ug5B
// module chunks = 86